const DEBUG_MODE = false;
// "NET" or "VAT"
const VAT_MODE = "NET";
// Remmebr to update free shipping banner and shipping costs on cart page
const FREE_SHIPPING_TOTAL = 150;
const TIER_FIVE_LIMIT = 350;
const TIER_SEVENPOINTFIVE_LIMIT = 1000;
const TIER_TEN_LIMIT = 1500;


const formatFinance = (number) =>
  new Intl.NumberFormat("en-UK", {
    style: "currency",
    currency: "GBP",
  }).format(number);
  
  const showShippingNotice = () => {
    DEBUG_MODE && console.log("show ship fired");
    const fst = FREE_SHIPPING_TOTAL;
    const sc = document.getElementById("free-shipping-notice");
    sc.innerHTML = ``;    
    
    const pt = document.getElementById("price-tier-notice");
    const li = pt.getAttribute("data-iacali") ?? "true";
  const wv = pt.getAttribute("data-page") ?? "false";
  pt.innerHTML = ``;

  const np = document.getElementById("totalCartWithPrice");
  const pe = document.querySelector(".csapps-cart-total");
  const po = document.querySelector(".csapps-cart-original-total");
  const p =
    VAT_MODE === "NET"
      ? pe.innerText.length >= 1
        ? justNumbers(pe.innerText)
        : justNumbers(po.innerText)
      : justNumbers(np.innerText);

  const tier =
    p <= TIER_FIVE_LIMIT
      ? TIER_FIVE_LIMIT
      : p <= TIER_SEVENPOINTFIVE_LIMIT
      ? TIER_SEVENPOINTFIVE_LIMIT
      : TIER_TEN_LIMIT;

  const fin = formatFinance(fst - p);
  const finT = formatFinance(tier - p);

  if (p < fst) {
    let pg = (p / fst) * 100;
    sc.innerHTML = `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center">Spend<strong id="shippingPrice"> ${fin} </strong>more for <strong>free shipping</strong>!</div><div class="free-shipping-notice__bar mt-3" style="--progress: ${
      pg < fst ? pg : 100
    }%" id="free-shipping-notice__bar"></div></div></div>`;
    sc.style.transform = "scaleY(1)";
  } else {
    sc.innerHTML = `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="20000"><div class="free-shipping-notice__heading mb-2 text-center"><strong id="shippingPrice">Your order is eligible for free shipping!</strong></div><div class="free-shipping-notice__bar mt-3" style="--progress: 100%" id="free-shipping-notice__bar"></div></div></div>`;
    sc.style.transform = "scaleY(1)";
  }

  tier <= 350 ? "" : "" ? "" : "";

  if (pt) {
    DEBUG_MODE && console.log("price tier notice fired", pt, p, p < TIER_TEN_LIMIT);    
    if (p < TIER_TEN_LIMIT) {
      let prg = (p / tier) * 100;            
      
      const msg = tier <= 350
      ? li === "false"
      ? ``
      : `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center">You are<strong id="shippingPrice"> ${finT} </strong>away from our <strong>5%</strong> discount tier!</div><div class="free-shipping-notice__bar mt-3" style="--progress: ${prg}%" id="free-shipping-notice__bar"></div></div></div>`
      : tier <= 1000
      ? li === "false"
      ? `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center">Logged in customers would get <strong>5%</strong> off this order...${
        wv === "side-cart" ? "<br />" : " "
        }<strong><a href="https://www.atlasflowers.co.uk/account/register" style="text-decoration:underline">Join Atlas Flowers</a></strong></div></div>`
        : `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center"><strong>5% discount added...</strong> spend<strong id="shippingPrice"> ${finT} </strong>more to reach our <strong>7.5%</strong> discount tier!</div><div class="free-shipping-notice__bar mt-3" style="--progress: ${prg}%" id="free-shipping-notice__bar"></div></div></div>`
        : li === "false"
        ? `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center">Logged in customers would get <strong>7.5%</strong> off this order...${
          wv === "side-cart" ? "<br />" : " "
          }<strong><a href="https://www.atlasflowers.co.uk/account/register" style="text-decoration:underline">Join Atlas Flowers</a></strong></div></div>`
          : `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center"><strong>7.5% discount added...</strong> spend<strong id="shippingPrice"> ${finT} </strong>more to reach our <strong>10%</strong> discount tier!</div><div class="free-shipping-notice__bar mt-3" style="--progress: ${prg}%" id="free-shipping-notice__bar"></div></div></div>`;
          
          DEBUG_MODE && console.log("Checking -", 
            tier <= 350, li === "false", "\n", "MSG -", msg)

      pt.innerHTML = msg
      
    } else {
      pt.innerHTML = `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center"><strong id="shippingPrice">You've qualified for 10% order discount!</strong></div><div class="free-shipping-notice__bar mt-3" style="--progress: 100%" id="free-shipping-notice__bar"></div></div></div>`;      
      DEBUG_MODE && console.log("show ship finished");
    }
  }
};

const fadeOut = (el, time) => {
  let opac = 1;
  const fade = setInterval(() => {
    opac = opac - 0.1;
    el.style.opacity = opac;
  }, 50);
  setTimeout(() => {
    clearInterval(fade);
  }, time);
};

setErrorMessage = (error) => {
  if (error.includes("You can't")) {
    const trimEnd = error.replace(" to the cart.", "");
    const trimStart = trimEnd.replace("You can't add more ", "");
    const errorBox = document.querySelectorAll(`[data-product-name=${'"' + trimStart + '"'}]`);
    errorBox.forEach((eb) => {
      eb.removeAttribute("hidden");
      eb.style.opacity = 1;
      eb.style.position = "absolute";
    });
  } else {
    const errorBox = document.getElementById(error);
    errorBox.removeAttribute("hidden");
    errorBox.innerText = `You can't add more ${errorBox.dataset.productName} to the cart`;
    errorBox.style.opacity = 1;
    errorBox.style.position = "absolute";
  }
};

const getLnsCont = () => {
  return document.getElementById("cart-items").querySelector(".cart_wrapper");
};

const justNumbers = (inputString) => inputString.replace(/[^0-9\.]+/g, "");
const getNet = (gross) => (parseFloat(gross) / 6) * 5;

const waitForElementToExist = (selector) => {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    const observerOptions = {
      childList: true,
      subtree: true,
    };

    observer.observe(document.body, observerOptions);
  });
};

const writePrice = (el, price) => {
  el.innerText = formatFinance(price);
};

const showEachPrice = (cartLines) => {
  cartLines.forEach((cartLine) => {
    writePrice(cartLine.unitPrice, justNumbers(cartLine.subtotal.innerText) / cartLine.qty);
  });
};

const getCartLines = (cartLinesContainer) => {
  // const allLines = [...cartLinesContainer.querySelectorAll('[id*="cart-item"]')];
  const allLines = [...document.querySelectorAll('[id*="cart-item-"]')];

  const cartLines = allLines.map((line) => {
    const getCartLineUnitPriceElement = () =>
      [...line.children].map((line) => line.querySelector("#lineUnitPrice")).filter((i) => i)[0];

    const getCartLineSubtotalElement = () => {
      const productLine = line.querySelector('[id*="product_"]');
      if (productLine.firstChild.className === "money") {
        return productLine.firstChild;
      } else {
        const getSpans = [...productLine.getElementsByTagName("span")];
        return getSpans.find((span) => span.classList.contains("cs_final_price"));
      }
    };
    
    const subtotal = getCartLineSubtotalElement();
    const subtotalAmount = getCartLineSubtotalElement() ? getCartLineSubtotalElement().innerText : "";
    const subtotalAmountIncTax = formatFinance(justNumbers(getCartLineSubtotalElement().innerText) * 1.2);
    const unitPrice = getCartLineUnitPriceElement();

    return {
      line: line.id,
      qty: line.querySelector("input").value,
      unitPrice,
      subtotal,
      subtotalAmount,
      subtotalAmountIncTax,
      taxStatus: line.querySelector('[id*="product_t"]') ? "Inc VAT" : "Exc VAT",
    };
  });  
  return cartLines;
};

const removeLoading = () => {
  const allLinePrices = [...document.getElementsByClassName("cart-price-container")];
  const cartTotalContainer = document.getElementById("cartTotalContainer");
  const drawerTotalContainer = document.getElementById("drawer-total-container");
  cartTotalContainer && allLinePrices.push(cartTotalContainer);
  drawerTotalContainer && allLinePrices.push(drawerTotalContainer);
  allLinePrices.forEach((elem) => (elem.style.opacity = 1));
  // remove spinner 
  const loadingSpinner = document.querySelector(".cart-item__loader");
  loadingSpinner.setAttribute("hidden", false);
};

const createTaxLines = (containerElement, grossPrice) => {
  const createMoneySpanTotal = document.createElement("span");
  const showIncTax = document.createElement("span");
  createMoneySpanTotal.id = "totalCartWithPrice";
  createMoneySpanTotal.className = "money";
  createMoneySpanTotal.innerText = formatFinance(grossPrice);
  createMoneySpanTotal.style.fontSize = "16px !important";
  showIncTax.appendChild(createMoneySpanTotal);
  showIncTax.className = "show-cart-total-inc";
  containerElement.appendChild(showIncTax);
};

const returnTotalCart = () => {
  const cartPriceContainer = document.getElementById("totalCartPrice");
  const twda = cartPriceContainer.querySelector(".csapps-cart-total");
  const twoda = cartPriceContainer.querySelector(".csapps-cart-original-total");

  if (!!twda) {
    return twda.innerText;
  } else if (!!twoda) {
    const twodap = twoda.innerText;
    const addPrice = document.createElement("span");
    addPrice.innerHTML = `<span class="csapps-cart-total"><span class="money">${twodap}</span></span>`;
    twoda.parentElement.appendChild(addPrice);
    return twodap;
  } else {
    DEBUG_MODE && console.log("Error getting total");
  }
};

const setSpinner = () => {

  const loadingSpinner = document.querySelector(".cart-item__loader");
  loadingSpinner.setAttribute("hidden", false);

  setTimeout(() => {
    const isEmpty = () => document.getElementById("cart-drawer-form").querySelectorAll(".cart-empty").length >= 1;
  DEBUG_MODE &&
    console.log("isEmpty", isEmpty(), document.getElementById("cart-drawer-form").querySelectorAll(".cart-empty"));
  
    if (isEmpty()) {      
      const pt = document.getElementById("price-tier-notice");
      pt.innerHTML = "";
      loadingSpinner.setAttribute("hidden", true);
    } else {
      DEBUG_MODE && console.log("Spinner fired", loadingSpinner.hidden, loadingSpinner);    
      if (loadingSpinner.hidden) {
        DEBUG_MODE && console.log("Removing loading spinner...");
        loadingSpinner.setAttribute("hidden", true);      
      } else {
        DEBUG_MODE && console.log("Showing Loading spinner...");
        loadingSpinner.setAttribute("hidden", false);
      }
    }
  }, 1000)
};

const cartTotalChanges = () => {
  const addedLines = document.getElementById("totalCart");
  const taxLine = document.getElementById("totalTax");
  const cartPrice = returnTotalCart();
  const cartTotalNetPrice = justNumbers(cartPrice);
  const cartTotalGrossPrice = justNumbers(cartPrice) * 1.2;
  const newElem = document.createElement("span");
  newElem.innerHTML = `<span class="money">${cartPrice}</span>`;
  newElem.className = "show-cart-total-ex";

  if (addedLines.querySelector(".show-cart-total-inc")) {
    const totalIncVat = addedLines.querySelector("#totalCartWithPrice");
    totalIncVat.innerText = formatFinance(cartTotalGrossPrice);
  } else {
    createTaxLines(addedLines, cartTotalGrossPrice);
  }
  addedLines.insertBefore(newElem, addedLines.children[0]);
  taxLine.innerText = formatFinance(cartTotalGrossPrice - cartTotalNetPrice);
};

const reloadPrices = (ce) => {
  showEachPrice(ce);
  ce.forEach((c) => {
    const lineId = document.getElementById(c.line);
    const linePrice = lineId.querySelector("#lineUnitPrice");
    linePrice.innerText = c.unitPrice.innerText;
  });
  cartTotalChanges();
  removeLoading();
  showShippingNotice();  
  DEBUG_MODE && console.log("reload prices finished", ce);
};

const showNetPrice = (itemsChanged) => {
  const containerElem = getLnsCont();
  let cartLines = [{}];
  cartLines = getCartLines(containerElem);
  DEBUG_MODE && cartLines.forEach((cartLine) => console.log(`Line ${cartLine.line}`, cartLine.unitPrice.innerText));

  if (itemsChanged === "add") {
    DEBUG_MODE && console.log("add fired");
    const checkForNewLines = async () => {
      DEBUG_MODE && console.log("check new lines fired");

      fetch("/cart.js", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      })
        .then((response) => {
          response
            .json()
            .then((i) => {
              const res = i;
              DEBUG_MODE && console.log("cart:", res);
              if (cartLines.length !== res.items.length) {
                let ce = getCartLines(getLnsCont());
                reloadPrices(ce);
                setTimeout(() => {
                  let ce = getCartLines(getLnsCont());
                  reloadPrices(ce);
                }, 1500);
              }
            })
            .catch((e) => DEBUG_MODE && console.log("Error:", e));
        })
        .catch((error) => console.error(error));
    };
    checkForNewLines();
  } else if (itemsChanged === "change") {
    DEBUG_MODE && console.log("change fired");
    let ce = getCartLines(getLnsCont());
    reloadPrices(ce);
  } else if (itemsChanged === "error") {
    DEBUG_MODE && console.log("error fired");
    reloadPrices(cartLines);
    const errors = document.querySelectorAll('[id*="line-item-error"]');
    errors.forEach((error) => {
      if (error.style.opacity > 0) {
        setTimeout(() => {
          fadeOut(error, 500);
          setTimeout(() => {
            errors.forEach((error) => error.setAttribute("hidden", true));
          }, 500);
        }, 1500);
      }
    });
  } else {
    reloadPrices(cartLines);
  }

  setSpinner(false);
  DEBUG_MODE && cartLines.forEach((cartLine) => console.log(`Line ${cartLine.line}`, cartLine.unitPrice.innerText));
};

document.addEventListener("DOMContentLoaded", () => {
  const cartItems = document.querySelectorAll("cart-items");
  setSpinner();
  cartItems.forEach((cart) => {
    if (!!cart.cartDrawer) {
      DEBUG_MODE && console.log("Looking for element in cart drawer");
      waitForElementToExist(".csapp-price-wrapper").then(() => showNetPrice());
    } else {
      DEBUG_MODE && console.log("Looking for element in cart");
      waitForElementToExist(".csapp-price-wrapper").then(() => showNetPrice());
    }
  });

  document.addEventListener("on:line-item:change", (e) => {
    DEBUG_MODE && console.log("changed", e);
    setSpinner();
    waitForElementToExist(".csapp-price-wrapper").then(() => showNetPrice("change"));
  });

  // Track add or remove items
  // track add/remove event listener/trigger
  document.addEventListener("on:cart:add", (e) => {
    DEBUG_MODE && console.log("Added", e);
    setSpinner();
    waitForElementToExist(".csapp-price-wrapper").then(() => showNetPrice("add"));
  });
});

document.addEventListener("on:cart:error", (err) => {
  DEBUG_MODE && console.log("cart error, ", err);
  setSpinner();
  setErrorMessage(err.detail.error);
  waitForElementToExist(".csapp-price-wrapper").then(() => showNetPrice("error"));
});
